import { useState } from "react";
import { notifyApi } from "../api/jeopardy";

export const useNotify = ({ refetch }: { refetch: () => void }) => {

    const [isNotify, setIsNotify] = useState(false);

    const handleOpenNotify = () => setIsNotify(true);
    const handleCloseNotify = () => setIsNotify(false);

    const [notifyData, setNotifyData] = useState({
        keyPerson: [] as any[] | [],
        notifyVia: [] as string[]
    });

    const handleSubmitNotify = async ({ jeopardy_ref }: { jeopardy_ref: string }) => {
        const payload = {
            "recipients":
                notifyData.keyPerson.map((value) => {
                    return {
                        "user_id": value
                    };
                }),
            "channels": notifyData.notifyVia,
            "referenceType": "JEOPARDY",
            "reference": jeopardy_ref
        };
        await notifyApi.sendNotify(payload);
        handleCloseNotify();
        refetch();
    };

    return {
        isNotify,
        handleOpenNotify,
        handleCloseNotify,
        notifyData,
        setNotifyData,
        handleSubmitNotify
    };

};